import classNames from 'classnames'

import Markdown from '../../Markdown/Markdown'
import styles from './DescriptionCard.module.scss'

const DescriptionCard = ({ description }) => {
  return (
    <Markdown
      content={description || ''}
      className={classNames(styles['description-container'])}
    />
  )
}

export default DescriptionCard
